import { SMS_CONSENT_TEXT } from "@/data/legal";

/**
 * A reusable SMS opt-in field shown on every form that collects a phone number.
 * - The checkbox is unchecked by default.
 * - The component renders the exact disclosure language required by carriers.
 *
 * Props:
 *  - checked, onChange, testId
 *  - required (defaults true) — should be true whenever a phone has been entered.
 */
export default function SmsConsent({ checked, onChange, testId = "sms-consent", required = true }) {
  return (
    <label
      data-testid={`${testId}-label`}
      className="mt-2 flex items-start gap-3 cursor-pointer select-none"
    >
      <input
        type="checkbox"
        data-testid={testId}
        checked={!!checked}
        onChange={(e) => onChange(e.target.checked)}
        required={required}
        className="mt-1 h-4 w-4 shrink-0 appearance-none border border-bone/40 bg-transparent checked:bg-brass checked:border-brass focus:outline-none focus:ring-1 focus:ring-brass cursor-pointer relative
                   checked:after:content-['✓'] checked:after:absolute checked:after:inset-0 checked:after:flex checked:after:items-center checked:after:justify-center checked:after:text-obsidian checked:after:text-[11px] checked:after:leading-none"
      />
      <span className="text-bone/55 text-[11px] leading-relaxed">
        {SMS_CONSENT_TEXT}
      </span>
    </label>
  );
}
